import { render, staticRenderFns } from "./nylasPop.vue?vue&type=template&id=ca7dc5b6&scoped=true&"
import script from "./nylasPop.vue?vue&type=script&lang=js&"
export * from "./nylasPop.vue?vue&type=script&lang=js&"
import style0 from "./nylasPop.vue?vue&type=style&index=0&id=ca7dc5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7dc5b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7dc5b6')) {
      api.createRecord('ca7dc5b6', component.options)
    } else {
      api.reload('ca7dc5b6', component.options)
    }
    module.hot.accept("./nylasPop.vue?vue&type=template&id=ca7dc5b6&scoped=true&", function () {
      api.rerender('ca7dc5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/newProject/dashboard/nylasPop.vue"
export default component.exports